// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"Contact_contactForm__21VJM","formBody":"Contact_formBody__1CIux"};